import { useEffect, useState } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="landing-root"
      className="relative min-h-screen overflow-hidden bg-[#050505] text-white"
    >
      {/* Ambient aurora glows */}
      <div
        aria-hidden
        className="aurora bg-[#6D28D9]"
        style={{ top: "-20%", left: "-10%", width: "60vw", height: "60vw" }}
      />
      <div
        aria-hidden
        className="aurora bg-[#3B0764]"
        style={{ top: "40%", right: "-20%", width: "55vw", height: "55vw", opacity: 0.35 }}
      />

      <div className="relative z-10">
        <Nav scrolled={scrolled} />
        <main>
          <Hero />
          <About />
          <Services />
          <Process />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
}
